
define('text!modules/news/news_template.html',[],function () { return '<div class="js-news-header"></div>\r\n<div class="js-news-list"></div>\r\n';});

